import { requireAuth, signInWithGoogle } from "./auth";
import cachedFirestore from "./cachedFirestore";
import { showCommunityFeed } from "./community/feed";
import {
  communityLevelWonAddReviewBtns,
  communityLevelWonToggleFavorite,
  submitLevelWonReviewData,
} from "./community/level";
import config, {
  ACHIEVEMENTS_ENABLED,
  BOARD_ASPECT_RATIO,
  BOOSTER_IAP_ENABLED,
  ENABLE_SHAKING,
  IS_IOS,
  IS_SAFARI,
  IS_CHROME,
  IS_CHROMIUM,
  IS_WEB,
  LOOSE_LIFE_RECOVERY_TIME,
  MIN_ASPECT_RATIO,
  RUN_EFFECTS_PARALLEL,
  SET_CELL_SHADOW,
  TRANSLATE_ENABLED,
} from "./config";
import {
  barsEl,
  communityFabEl,
  communityNavBtnEls,
  exitGameDialogCancelEl,
  exitGameDialogEl,
  exitGameDialogFeedbackEl,
  exitGameDialogOkEl,
  feedbackDialogEl,
  feedbackScrollContainerEl,
  feedbackThanksCancelEl,
  feedbackThanksEl,
  feedbackThanksOkEl,
  gameEl,
  levelIndicatorEl,
  loseLifeDialogCancelEl,
  loseLifeDialogEl,
  loseLifeDialogOkEl,
  menuAutoTranslateBtnEl,
  menuCloseBtnEl,
  menuDifficultyBtnEl,
  menuEarnBtnEl,
  menuFeedbackBntEl,
  menuInviteFriendBtnEl,
  menuMainMenuBtnEl,
  menuMapBtnEl,
  menuMusicBtnEl,
  menuOpenBtnEl,
  menuProfilePhotoBtnEl,
  menuProfilePhotoCaptionEl,
  menuProfilePhotoIconEl,
  menuProfilePhotoImgEl,
  menuProfilePhotoUnameEl,
  menuRmAdsBtnEl,
  menuShutdownBtnEl,
  menuVersionBtnEl,
  nextEpisodeEl,
  noLivesCloseBtnEl,
  noLivesEl,
  noLivesElCta,
  noLivesElCtaContainer,
  noLivesElCtaInviteFriend,
  noLivesElCtaRewardVideo,
  overlayEl,
  pickLevelCloseBtnEl,
  playClassicBtnEl,
  playCommunityBtnEl,
  playLoginBtnEl,
  playQuestBtnEl,
  previousEpisodeEl,
  replayCommunityCancelBtnEl,
  replayCommunityDialogEl,
  replayDialogCancelEl,
  replayDialogEl,
  replayDialogOkEls,
  replayFavEl,
  replayFiveStarReviewBtnEl,
  replayFourStarReviewBtnEl,
  replayOneStarReviewBtnEl,
  replaySpeedControlBtnEls,
  replayThreeStarReviewBtnEl,
  replayTwoStarReviewBtnEl,
  showTipBtnEl,
  signInDialogCancelBtnEl,
  signInDialogEl,
  signInDialogSignInBtnEl,
  tellUsWhatYouThinkBtnEl,
} from "./elements";
import { addTouchEvent } from "./events";
import { initCanvas } from "./explode";
import { newGame, resizeGameEl } from "./game";
import {
  handleEditingState,
  handleEditorUpdate,
  initEditorPlacements,
} from "./game/editor";
import { GAME_MODE, gameEditorState, gameState } from "./game/gameState";
import { toggleTip } from "./game/helper";
import { fillUpLives, getAndSetIAPInfo, removeAds } from "./iap";
import { handleSubscribed } from "./iap/subscription";
import {
  closePickLevel,
  lvlCfg,
  placement,
  setLevelIndicators,
} from "./levels";
import { CLASSIC_LEVELS } from "./levels/definitions";
import { earnLive, livesFromTimeDelta, updateLives } from "./lives";
import { playClassic, playQuest, showMainMenu } from "./mainMenu";
import "./map";
import {
  closeLoseLifeDialog,
  gotoMapOrMainMenu,
  nextEpisode,
  play,
  prevEpisode,
  showLoseLifeDialog,
  showMap,
} from "./map";
import { closeMenu, openMenu } from "./menu";
import { setMusic, switchMusicCb } from "./music";
import { stack } from "./nav";
import { updateStyles } from "./nav/styles";
import "./network";
import {
  AdMob,
  App,
  NavigationBar,
  RateApp,
  SplashScreen,
  StatusBar,
} from "./plugins";
import { showProfile } from "./profile";
import "./radioBtn";
import { setSpeedControl, shareGame } from "./recordGame";
import "./remoteConfig";
import "./ripple";
import {
  createInviteFriendShortLink,
  hasInvitees,
  inviteFriendCb,
  listenToDeepLinkOpen,
  removeShareIfNotSupported,
} from "./share";
import { addClickToBtns } from "./sound";
import { withSpinner } from "./spinner";
import store from "./store";
import {
  setColors,
  setNavigationBarColor,
  setSystemBarsThemeInterval,
} from "./style";
import "./translate";
import {
  autoTranslate,
  autoTranslateElements,
  setTranslation,
} from "./translate";
import { showWhatsNew } from "./whatsnew";
import "./feedback";
import { getLogger } from "./logging";
if (IS_WEB) require("./unsupportedBroswer");
if (__DEV__) require("./dev");
if (__ADMIN__) require("./admin");

const log = getLogger("Main");

listenToDeepLinkOpen();

log.debug({
  IS_WEB,
  IS_SAFARI,
  IS_CHROME,
  IS_CHROMIUM,
  LOOSE_LIFE_RECOVERY_TIME,
  RUN_EFFECTS_PARALLEL,
  MIN_ASPECT_RATIO,
  BOARD_ASPECT_RATIO,
  SET_CELL_SHADOW,
  ENABLE_SHAKING,
  BOOSTER_IAP_ENABLED,
  TRANSLATE_ENABLED,
  ACHIEVEMENTS_ENABLED,
  ...config,
  __DEV__,
  __IFRAME__,
  __INSTANT__,
});

function setup() {
  StatusBar.hide();
  Array.prototype.forEach.call(barsEl, (element) => {
    element.style.display = "none";
  });

  setLevelIndicators();
  setColors();
  updateStyles();
}

App.addListener("appStateChange", ({ isActive }) => {
  if (isActive) {
    log.debug("App became active");
    IS_IOS || NavigationBar.hide();
    setup();
    setNavigationBarColor(store.themes[2], store.themes[5]);
  }
});

getAndSetIAPInfo(["fill_up_lives", "rm_ads"]).finally(handleSubscribed);
StatusBar.hide();
IS_IOS || NavigationBar.hide();
removeShareIfNotSupported();
// handleIntro();
livesFromTimeDelta();
// handleLivesModal();
updateLives();
// showMap();
setup();

addTouchEvent(menuCloseBtnEl, closeMenu, false);
addTouchEvent(menuOpenBtnEl, openMenu, false);
addTouchEvent(pickLevelCloseBtnEl, closePickLevel, false);
// addTouchEvent(levelIndicatorEl, setLevelCb);
// if (!SUBSCRIPTION_OFF) {
//   addTouchEvent(subscribeCloseBtnEl, closeSubscribe);
//   addTouchEvent(selectYearlyEl, selectYearly);
//   addTouchEvent(selectMonthlyEl, selectMonthly);
//   addTouchEvent(subscribeNowBtnEl, subscribePro);
// }
// addTouchEvent(menuShareBtnEl, shareCb);
// addTouchEvent(menuOpenLeaderboardBtnEl, openLeaderboardMenuCb);
// addTouchEvent(menuAchievementsBtnEl, openAchievementsCb);
addTouchEvent(menuMusicBtnEl, (e) => {
  switchMusicCb(e);
  autoTranslate();
});
addTouchEvent(menuMapBtnEl, (event) => {
  loseLifeDialogEl.dataset.destination = "map";
  if (store.maxLevelIdx != store.levelIdx) gotoMapOrMainMenu(event);
  else showLoseLifeDialog();
});
addTouchEvent(loseLifeDialogOkEl, gotoMapOrMainMenu);
addTouchEvent(loseLifeDialogCancelEl, closeLoseLifeDialog);
addTouchEvent(previousEpisodeEl, prevEpisode);
addTouchEvent(nextEpisodeEl, nextEpisode);
addTouchEvent(noLivesElCta, fillUpLives);
const earnLive_ = () => earnLive(AdMob);
addTouchEvent(noLivesElCtaRewardVideo, earnLive_);
addTouchEvent(noLivesElCtaInviteFriend, inviteFriendCb);
addTouchEvent(menuEarnBtnEl, earnLive_);
addTouchEvent(menuRmAdsBtnEl, removeAds);
addTouchEvent(playClassicBtnEl, playClassic);
addTouchEvent(playQuestBtnEl, playQuest);
addTouchEvent(menuMainMenuBtnEl, showMainMenu);
addTouchEvent(noLivesCloseBtnEl, () => {
  showMainMenu();
  noLivesEl.classList.remove("visible");
  noLivesElCtaContainer.classList.remove("visible");
});

const changeClassicLevelIdx = () => {
  store.set(
    "classicLevelIdx",
    (store.classicLevelIdx + 1) % CLASSIC_LEVELS.length
  );
  menuDifficultyBtnEl.textContent = `🔢 Difficulty: ${
    ["Easy", "Medium", "Hard"][store.classicLevelIdx]
  }`;
  levelIndicatorEl.innerHTML = ["&nbsp&nbsp&nbspEasy", "Medium", "Hard"][
    store.classicLevelIdx
  ];
  newGame({
    increaseGameCount: false,
    level: CLASSIC_LEVELS[store.classicLevelIdx],
  });
  autoTranslateElements(menuDifficultyBtnEl, levelIndicatorEl);
};
addTouchEvent(menuDifficultyBtnEl, changeClassicLevelIdx);
addTouchEvent(menuInviteFriendBtnEl, inviteFriendCb);
addTouchEvent(replayDialogCancelEl, () => {
  store.gameFramesReplaying = [];
  replayDialogEl.style.display = null;
  if (gameState.mode == GAME_MODE.CLASSIC)
    newGame({
      level: CLASSIC_LEVELS[store.classicLevelIdx],
    });
});
addTouchEvent(replayCommunityCancelBtnEl, () => {
  store.gameFramesReplaying = [];
  replayCommunityDialogEl.style.display = null;
  submitLevelWonReviewData();
});
// Array.from(replayDialogCancelEl).forEach((replayDialogCancelEl) =>
//   addTouchEvent(replayDialogCancelEl, () => {
//     store.gameFramesReplaying = [];
//     replayDialogEl.style.display = null;
//   })
// );

Array.from(replayDialogOkEls).forEach((replayDialogOkEl) =>
  addTouchEvent(replayDialogOkEl, shareGame)
);

addTouchEvent(replayOneStarReviewBtnEl, communityLevelWonAddReviewBtns(0));
addTouchEvent(replayTwoStarReviewBtnEl, communityLevelWonAddReviewBtns(1));
addTouchEvent(replayThreeStarReviewBtnEl, communityLevelWonAddReviewBtns(2));
addTouchEvent(replayFourStarReviewBtnEl, communityLevelWonAddReviewBtns(3));
addTouchEvent(replayFiveStarReviewBtnEl, communityLevelWonAddReviewBtns(4));
addTouchEvent(replayFavEl, communityLevelWonToggleFavorite);

addTouchEvent(feedbackThanksOkEl, () =>
  window.open(
    "https://play.google.com/store/apps/details?id=com.kima.chatnoirhex&showAllReviews=true",
    "_blank"
  )
);
addTouchEvent(
  feedbackThanksCancelEl,
  () => (feedbackThanksEl.style.display = "none")
);
const _feedback = () => {
  feedbackDialogEl.style.display = "initial";
  feedbackScrollContainerEl.scrollTo({ top: 0 });
};
addTouchEvent(exitGameDialogFeedbackEl, _feedback);
addTouchEvent(menuFeedbackBntEl, _feedback);
addTouchEvent(tellUsWhatYouThinkBtnEl, _feedback);
addTouchEvent(menuAutoTranslateBtnEl, () => {
  store.set("disableTranslate", !store.disableTranslate);
  setTranslation();
  autoTranslate();
});

Array.from(replaySpeedControlBtnEls).forEach((replaySpeedControlBtnEl) => {
  addTouchEvent(replaySpeedControlBtnEl, () => {
    store.set("fastPlayback", !store.fastPlayback);
    setSpeedControl(replaySpeedControlBtnEl);
  });
  setSpeedControl(replaySpeedControlBtnEl);
});

createInviteFriendShortLink();
hasInvitees();
// unlockAllAchievements(store.maxLevelIdx);

// play(store.maxLevelIdx);

stack.push("main_menu");

// randomly request review
if (store.gaveFiveStarsReview && Math.random() < 0.1) {
  log.debug("Requesting review");
  RateApp.requestReview();
}

addTouchEvent(
  menuShutdownBtnEl,
  () => (exitGameDialogEl.style.display = "block")
);
addTouchEvent(exitGameDialogOkEl, (e) => {
  exitGameDialogEl.style.display = "none";
  showMainMenu(e, true);
  App.minimizeApp();
});
addTouchEvent(
  exitGameDialogCancelEl,
  () => (exitGameDialogEl.style.display = "none")
);
addTouchEvent(showTipBtnEl, () => toggleTip(true));
addTouchEvent(playLoginBtnEl, () => withSpinner(signInWithGoogle()));
addTouchEvent(signInDialogSignInBtnEl, async () => {
  await withSpinner(signInWithGoogle());
  signInDialogEl.style.display = null;
});
addTouchEvent(
  signInDialogCancelBtnEl,
  () => (signInDialogEl.style.display = null)
);
addTouchEvent(menuProfilePhotoBtnEl, () => {
  if (store.user.uid) showProfile();
  else signInWithGoogle();
});
addTouchEvent(playCommunityBtnEl, () => {
  cachedFirestore.clearCollectionCache("communityLevels");
  showCommunityFeed();
  //   playQuest();
  //   play({ delay: 0, editor: true });
});
addTouchEvent(
  communityFabEl,
  requireAuth(async () => {
    gameState.mode = GAME_MODE.EDITOR;
    gameEditorState.editing = true;
    if (Object.keys(store.levelEditing).length) {
         play({ delay: 0, level: store.levelEditing });
        initEditorPlacements();
    } else {
         play({
            delay: 0,
            level: lvlCfg({
                placements: [],
                catPlacement: placement(null, [], null),
            }),
        });
    }
    handleEditingState();
    handleEditorUpdate();
  })
);
communityNavBtnEls[store.communityNavIdx].classList.add("selected");
communityNavBtnEls[store.communityNavIdx].classList.remove("text-on-white");
Array.from(communityNavBtnEls).forEach((el, idx) =>
  addTouchEvent(
    el,
    requireAuth(() => {
      if (idx == 0) showProfile(store.user.uid);
      else {
        communityNavBtnEls[store.communityNavIdx].classList.remove("selected");
        communityNavBtnEls[store.communityNavIdx].classList.add(
          "text-on-white"
        );
        store.set("communityNavIdx", idx);
        communityNavBtnEls[store.communityNavIdx].classList.add("selected");
        showCommunityFeed();
      }
    })
  )
);

if (store.user.uid) {
  log.debug("User is logged in");
  playLoginBtnEl.style.display = "none";
  menuProfilePhotoCaptionEl.style.display = "none";
  menuProfilePhotoIconEl.style.display = "none";
  menuProfilePhotoImgEl.style.height = "100%";
  menuProfilePhotoImgEl.onerror = () => {
    log.warn("Error in image element");
    menuProfilePhotoImgEl.src = "img/placeholder.jpg";
  };
  menuProfilePhotoImgEl.src =
    store.profile.thumbnailUrl || store.user.photoUrl || "img/placeholder.jpg";
}

function hideSplashScreen() {
  setMusic();
  setTranslation();
  autoTranslate();
  overlayEl.style.display = "none";
  SplashScreen.hide()
    //   .then(handleIntro)
    .then(setSystemBarsThemeInterval);
}
setTimeout(hideSplashScreen, 500);

initCanvas();
setSystemBarsThemeInterval();

menuVersionBtnEl.innerHTML = `v${config.VERSION}`;
if (store.profile.uname) {
  menuProfilePhotoUnameEl.innerHTML = store.profile.uname;
  menuProfilePhotoUnameEl.style.display = "block";
}

const _resize = () => {
  log.info(`Resizing ${store.screenName} screen`);
  store.innerWidth = window.innerWidth;
  store.innerHeight = window.innerHeight;
  store.ar = window.innerWidth / window.innerHeight;
  resizeGameEl();
  const rEl = document.querySelector(":root");
  rEl.style.setProperty(
    "--scale",
    `${parseInt(gameEl.style.height) / 4.57 / 10.8}px`
  );
  switch (store.screenName) {
    case "map":
      showMap(true);
      break;
    default:
      break;
  }
  updateStyles();
};
addClickToBtns();
window.addEventListener("resize", _resize);
_resize();

if (store.isUpdate) showWhatsNew();

// if (__DEV__) {
//   playQuest();
//   gameState.mode = GAME_MODE.STORY;
//   play({ delay: 0, levelIdx: 0 });
// }

// require("./skinPicker");
